import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "booleanValue",
})
export class BooleanValuePipe implements PipeTransform {
  transform(value: boolean, replacementValues: string): string {
    if (replacementValues.includes(":")) {
      const [trueReplacement, falseReplacement] = replacementValues.split(":");
      return value ? trueReplacement.trim() : falseReplacement.trim();
    }
    return value ? replacementValues.trim() : "False";
  }
}
